import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=50e7c0a4&scoped=true&"
import script from "./modal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./modal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=50e7c0a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7c0a4",
  null
  
)

export default component.exports